__turbopack_context__.v({
  "desktopWrapper": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__desktopWrapper",
  "featureIcon": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon",
  "featureIcon10": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon10",
  "featureIcon11": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon11",
  "featureIcon12": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon12",
  "featureIcon13": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon13",
  "featureIcon14": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon14",
  "featureIcon15": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon15",
  "featureIcon16": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon16",
  "featureIcon17": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon17",
  "featureIcon18": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon18",
  "featureIcon2": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon2",
  "featureIcon3": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon3",
  "featureIcon4": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon4",
  "featureIcon5": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon5",
  "featureIcon6": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon6",
  "featureIcon7": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon7",
  "featureIcon8": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon8",
  "featureIcon9": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__featureIcon9",
  "freeBox": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__freeBox",
  "heading": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading",
  "heading10": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading10",
  "heading11": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading11",
  "heading12": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading12",
  "heading13": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading13",
  "heading14": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading14",
  "heading15": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading15",
  "heading16": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading16",
  "heading17": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading17",
  "heading18": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading18",
  "heading2": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading2",
  "heading3": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading3",
  "heading4": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading4",
  "heading5": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading5",
  "heading6": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading6",
  "heading7": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading7",
  "heading8": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading8",
  "heading9": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__heading9",
  "img___1DAoD": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img___1DAoD",
  "img___4L4V": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img___4L4V",
  "img__aSi1K": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__aSi1K",
  "img__eWPu0": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__eWPu0",
  "img__fMrt1": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__fMrt1",
  "img__h2Sx7": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__h2Sx7",
  "img__iDqet": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__iDqet",
  "img__jFi64": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__jFi64",
  "img__loTpS": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__loTpS",
  "img__mtntD": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__mtntD",
  "img__nYGjI": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__nYGjI",
  "img__oSkog": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__oSkog",
  "img__pkUXb": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__pkUXb",
  "img__r9XHr": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__r9XHr",
  "img__rAvi5": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__rAvi5",
  "img__tQnl6": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__tQnl6",
  "img__uui20": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__uui20",
  "img__vSsMg": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__img__vSsMg",
  "items": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__items",
  "mobileWrapper": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__mobileWrapper",
  "row5": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__row5",
  "row6": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__row6",
  "row7": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__row7",
  "row8": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__row8",
  "row9": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__row9",
  "tabletWrapper": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__tabletWrapper",
  "text10": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text10",
  "text11": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text11",
  "text12": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text12",
  "text13": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text13",
  "text14": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text14",
  "text15": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text15",
  "text16": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text16",
  "text17": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text17",
  "text18": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text18",
  "text19": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text19",
  "text20": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text20",
  "text21": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text21",
  "text22": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text22",
  "text5": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text5",
  "text6": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text6",
  "text7": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text7",
  "text8": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text8",
  "text9": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__text9",
  "textWithIcon": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon",
  "textWithIcon10": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon10",
  "textWithIcon11": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon11",
  "textWithIcon12": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon12",
  "textWithIcon13": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon13",
  "textWithIcon14": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon14",
  "textWithIcon15": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon15",
  "textWithIcon16": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon16",
  "textWithIcon17": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon17",
  "textWithIcon18": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon18",
  "textWithIcon2": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon2",
  "textWithIcon3": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon3",
  "textWithIcon4": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon4",
  "textWithIcon5": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon5",
  "textWithIcon6": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon6",
  "textWithIcon7": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon7",
  "textWithIcon8": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon8",
  "textWithIcon9": "PlasmicHomeBenefitsSectionBenefits-module__SUEiWq__textWithIcon9",
});
